import { useNavigate } from 'react-router-dom';

import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { useGetCompanyById } from 'src/hooks/companies/get-company-by-id.hook';
import { CompanyCommonForm } from 'src/pages/settings/components/company-profile/components/company-common-form';
import { useUploadCompanyLogoById } from 'src/hooks/companies/upload-company-logo.hook';
import { useUpsertCompany } from 'src/hooks/companies/upsert-company.hook';

const CompanyProfileEdit = () => {
  const navigate = useNavigate();
  const query = useRouteQuery();
  const id: string = query.get('id') || '';

  const { loading, company } = useGetCompanyById(id);
  const upsertCompany = useUpsertCompany({
    onSuccess: () => navigate(ROUTES.settings),
  });
  const uploadCompanyLogoById = useUploadCompanyLogoById();

  const onFinishHandler = (values: any) => {
    if (typeof values.logo !== 'string') {
      uploadCompanyLogoById({ variables: { logo: values.logo, companyId: company._id } });
    }

    values.logo = null;

    const payload = {
      ...values,
      datevNumberId: values.datevNumberId || null,
      locations: values.locations.map((location: any) => ({
        ...location,
        datevNumberId: location.datevNumberId || null,
        businessAddresses: location.businessAddresses.map((address: any) => {
          const { holidayLocation, ...dataToCreate } = address;
          return dataToCreate;
        }),
      })),
    };

    upsertCompany({
      variables: {
        payload: { ...payload, _id: id },
      },
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <CompanyCommonForm
      onCancel={() => navigate(ROUTES.settings)}
      onFinish={onFinishHandler}
      companyData={company}
    />
  );
};

export default CompanyProfileEdit;
